import React, { useState, useEffect, useContext } from 'react';
import Spinner from './Spinner';
import api from '../api';
import { ConversationProps, MessageType, AssistantRequest, AssistantResponse, ExistingChatProps } from '../types';
import Schema from './Schema';
import DocForm from './DocForm';
import AimdocResult from './search_results/AimdocResult';
import GDriveResult from './search_results/GDriveResult';
import { set } from 'lodash';
import useApi from '../api';
import DocMini from './DocMini';

const DocPanelCP = ({ document, isCollapsed, setIsCollapsed } : { document: any, isCollapsed: any, setIsCollapsed: any }) => {
    const [loading, setLoading] = useState(false);
    const [userInput, setUserInput] = useState('');
    const [isDocFormCollapsed, setIsDocFormCollapsed] = useState<boolean>(false);
    const [isSchemaCollapsed, setIsSchemaCollapsed] = useState<boolean>(true);

    const { get, getStream, post, postStream, put, patch, remove } = useApi();

    const toggleDocForm = () => {
        setIsDocFormCollapsed(!isDocFormCollapsed);
    };

    const toggleSchema = () => {
        setIsSchemaCollapsed(!isSchemaCollapsed);
    };

    const toggleSidebar = () => {
        setIsCollapsed(!isCollapsed);
    };

    const sidebarClass = () => {
            return isCollapsed ? 'w-4' : 'w-1/3';
    }

    useEffect(() => {
        if (document) {
            setIsCollapsed(false);
        }
    }, [document]);


        return (
            document && (
                <div className={`relative flex shadow-lg bg-gray-100 z-20 ${sidebarClass()} transition-all duration-20`}>
                <div className={`absolute top-8 -left-3 z-60 transform cursor-pointer rounded-full border`} onClick={toggleSidebar}>
                   <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="black" className={`w-6 h-6 transform ${isCollapsed ? 'rotate-180' : ''} transition-transform bg-white rounded-full shadow-md p-2`}>
                       <path fillRule="evenodd" d="M16.28 11.47a.75.75 0 0 1 0 1.06l-7.5 7.5a.75.75 0 0 1-1.06-1.06L14.69 12 7.72 5.03a.75.75 0 0 1 1.06-1.06l7.5 7.5Z" clipRule="evenodd" />
                   </svg>
               </div>
   {!isCollapsed && (
                       <div className="flex flex-col h-full w-full max-h-[calc(100vh-1px)]">
                       <div className="py-2 px-6 border-b bg-gray-300">
                           <p>
                               <span className="text-lg text-gray-700 font-bold uppercase">Document Build</span>
                           </p>
                       </div>
                       <DocMini document={document} />
                       </div>
   )}
   </div>
            )

        );
    };

export default DocPanelCP;